"use strict";
/*
 * Created on 10 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Vendor allowance is basically tool for decreasing purchase price of product based on company's deal with suppliers.
 * It is up to end application to determine single value of vendor allowance (with/without back bonus). It can be for
 * example:
 *      – simple avg across all active and external suppliers (vendor allowance should always be set to external suppliers)
 *      – weighted avg based on suppliers forecast
 *
 * @author JMe
 * @author Radek Beran
 */


var VendorAllowance =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(VendorAllowance, _DomainObject_1$Domai);

  /**
   * @param id the internal id of entity
   * @param productId the id of internal product
   * @param supplierId the id of supplier
   * @param validFrom the start date of validity (typically start of a month).
   * @param validTo the end date of validity (typically end of a month).
   * @param withBackBonus the value with back bonus as percentage value (at least this or without back bonus should be set)
   * @param withoutBackBonus the value without back bonus as percentage value (at least this or with back bonus should be set)
   * @param processed defines whether an instance was processed
   */
  function VendorAllowance(id, productId, supplierId, validFrom, validTo, withBackBonus, withoutBackBonus, processed) {
    var _this;

    _classCallCheck(this, VendorAllowance);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowance).call(this));
    _this.id = id;
    _this.productId = productId;
    _this.supplierId = supplierId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.withBackBonus = withBackBonus;
    _this.withoutBackBonus = withoutBackBonus;
    _this.processed = processed;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to vendor allowance.
   */


  _createClass(VendorAllowance, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new VendorAllowance(mat.id, mat.productId, mat.supplierId, mat.validFrom, mat.validTo, mat.withBackBonus, mat.withoutBackBonus, mat.processed);
    }
  }]);

  return VendorAllowance;
}(DomainObject_1.DomainObject);

exports.VendorAllowance = VendorAllowance; // tslint:disable-next-line:member-ordering

VendorAllowance.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(VendorAllowance.name);
  return {
    id: builder.id('id'),
    productId: builder.id('productId'),
    supplierId: builder.id('supplierId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    withBackBonus: builder.opt(builder.bigNum('withBackBonus')),
    withoutBackBonus: builder.opt(builder.bigNum('withoutBackBonus')),
    processed: builder.bool('processed')
  };
}();